export type DiagnosticSource =
  | 'environment' | 'dev-tool' | 'feature-flags' | 'project-timezone'
  | 'portal-login' | 'project-switch' | 'full-reload-guard' | 'column-cache'
  | 'route-mask' | 'ga' | 'copilot-module' | 'copilot-config'
  | 'micro-app-causal-inference' | 'micro-app-exp-series' | 'micro-app-unknown';

export type DegradationCode =
  | 'TIMEZONE_DEFAULTED' | 'CACHE_INVALIDATED' | 'STORAGE_UNAVAILABLE'
  | 'GA_UNAVAILABLE' | 'COPILOT_CONFIG_DEFAULTED' | 'MICRO_APP_LOAD_FAILED'
  | 'RUNTIME_CONTEXT_FALLBACK';

export type Diagnostic =
  | { kind: 'exception'; error: Error }
  | { kind: 'degradation'; code: DegradationCode; source: DiagnosticSource; detail?: string };

type DiagnosticSender = (diagnostic: Diagnostic) => void | PromiseLike<void>;
const pending: Diagnostic[] = [];
let sender: DiagnosticSender | undefined;

function send(diagnostic: Diagnostic): void {
  try {
    // 发送失败不重试、不递归报告，且不能阻断下一条早期记录。
    void Promise.resolve(sender?.(diagnostic)).catch(() => undefined);
  } catch {
    // 监控失败不影响业务。
  }
}

export function submitDiagnostic(diagnostic: Diagnostic): void {
  if (sender) {
    send(diagnostic);
  } else {
    if (pending.length === 20) pending.shift();
    pending.push(diagnostic);
  }
}

export function installDiagnosticSender(nextSender: DiagnosticSender): void {
  sender = nextSender;
  const queued = pending.splice(0);
  queued.forEach(send);
}

export function reportDegradation(diagnostic: {
  code: DegradationCode;
  source: DiagnosticSource;
  detail?: string;
}): void {
  try {
    submitDiagnostic({
      kind: 'degradation',
      code: diagnostic.code,
      source: diagnostic.source,
      ...(diagnostic.detail ? { detail: diagnostic.detail } : {}),
    });
  } catch {
    // 输入字段的 getter 也可能抛错，不能让诊断阻断业务降级。
  }
}
